import EventInfoCard from './EventInfoCard';
import { EVENT_THEMES } from '../config/eventThemes';

// Shown on the registration page when more than one event is currently accepting
// signups — lets the user see all of them and choose which to register for.
const EventPicker = ({ events, onSelect }) => {
  if (events.length === 0) {
    return (
      <div className="registration-container">
        <div className="registration-closed">
          <div className="closed-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 6v6l4 2"/>
            </svg>
          </div>
          <h2>Registration Closed</h2>
          <p className="closed-message">There are no events open for registration right now.</p>
          <p className="stay-tuned">Stay tuned for future Buddy Up community events and opportunities to connect.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="event-picker">
      <h1 className="event-picker-title">Choose an event to register for</h1>
      <div className="event-picker-list">
        {events.map((event) => {
          const theme = EVENT_THEMES[event.theme] || EVENT_THEMES.default;
          return (
            <button
              key={event.id}
              type="button"
              className="event-picker-item"
              onClick={() => onSelect(event)}
              aria-label={`Register for ${event.name}`}
            >
              <EventInfoCard event={event} />
              <span className="event-picker-cta" style={{ background: theme.accent }}>
                Register for this event →
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default EventPicker;
